import { useUserContext } from "@/context/user.context";
import {
  FEATURE_FLAGS,
  useFeatureIsOn,
  useGrowthBook,
} from "@/utils/growthbook";

/**
 * Single gate for the ATS Suite — the nav entry and every suite route
 * (landing page, integration validator, and future tools) share it:
 * internal users with the `ats-suite` GrowthBook flag enabled.
 *
 * `ready` distinguishes "still initializing user/GrowthBook" from
 * "definitively denied", so pages can show a loader first and redirect
 * without flashing gated content.
 */
export const useAtsSuiteAccess = () => {
  const { initialized, isInternal } = useUserContext();
  const gb = useGrowthBook();
  const flagEnabled = useFeatureIsOn(FEATURE_FLAGS.atsSuite);

  const ready = initialized && gb.ready;

  return { ready, hasAccess: ready && isInternal && flagEnabled };
};
